// removed by extract-text-webpack-plugin
module.exports = {"formWrapper":"DuB4WtUAsnHhvnL7JTikO","buttons":"_3jwKC6iD0QmI7uWn0fNfM0"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/UserProfile/components/ChangePasswordForm.mod.css
// module id = 1078
// module chunks = 0